import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../lib/api-client";
import { queryKeys } from "../query-keys";
import {
  ManagerAvailabilitySchema,
  type SaveManagerAvailabilityRequest,
} from "@applicant-reviewer/api";

// PUT /manager-availability — saves the current manager's weekly availability
export function useSaveManagerAvailability() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: SaveManagerAvailabilityRequest) =>
      apiClient.put("/manager-availability", ManagerAvailabilitySchema, data),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.managerAvailability.all });
    },
  });
}
